import { render, staticRenderFns } from "./WhatsAppPhoneField.vue?vue&type=template&id=8f0cfd76&scoped=true"
import script from "./WhatsAppPhoneField.vue?vue&type=script&lang=js"
export * from "./WhatsAppPhoneField.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppPhoneField.vue?vue&type=style&index=0&id=8f0cfd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0cfd76",
  null
  
)

export default component.exports